/* global fbq */
import { useEffect } from "react";

const FB_SDK_URL = "https://connect.facebook.net/en_US/sdk.js";
const ALLOWED_FACEBOOK_ORIGINS = ["https://www.facebook.com", "https://web.facebook.com"];

export const useFacebookSdk = ({ onSuccess, onCancel, onError, Permisson }) => {
  useEffect(() => {
    // Initialize Facebook SDK
    window.fbAsyncInit = function () {
      if (window.FB) {
        window.FB.init({
          appId: process.env.REACT_APP_FACEBOOK_APP_ID,
          cookie: true,
          xfbml: true,
          version: process.env.REACT_APP_FACEBOOK_API_VERSION,
        });
      }
    };

    // Load SDK asynchronously
    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = FB_SDK_URL;
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");

    const handleEmbeddedSignupMessages = (event) => {
      if (!ALLOWED_FACEBOOK_ORIGINS.includes(event.origin)) {
        return;
      }

      try {
        const data = JSON.parse(event.data);
        if (data.type === "WA_EMBEDDED_SIGNUP") {
          if (data.event === "CANCEL") {
            const { current_step } = data.data;
            console.warn("Cancel at ", current_step);
            if (onCancel) onCancel(current_step);
          } else if (data.event === "ERROR") {
            const { error_message } = data.data;
            console.error("error ", error_message);
            if (onError) onError(error_message);
          }
        }
      } catch (error) {
        console.log("Non JSON Response or parsing error", error);
      }
    };

    window.addEventListener("message", handleEmbeddedSignupMessages);
    return () => {
      window.removeEventListener("message", handleEmbeddedSignupMessages);
    };
  }, [onCancel, onError]);

  const loginWithFacebook = () => {
    if (typeof fbq !== "undefined") {
      fbq("trackCustom", "WhatsAppOnboardingStart", {
        appID: process.env.REACT_APP_FACEBOOK_APP_ID,
        feature: "whatsapp_embedded_signup",
      });
    }

    if (window.FB) {
      window.FB.login(
        (response) => {
          if (response.authResponse) {
            const { code } = response.authResponse;
            if (onSuccess) onSuccess(code);
          }
        },
        {
          scope: "public_profile,email",
          config_id: process.env.REACT_APP_FACEBOOK_CONFIG_ID,
          response_type: "code",
          override_default_response_type: true,
          extras: {
            setup: {
              ...(Permisson?.includes("BSPA") && {
                solutionID: process.env.REACT_APP_FACEBOOK_SOLUTION_ID,
              }),
            },
            featureType: "",
            sessionInfoVersion: "3",
          },
        }
      );
    } else {
      console.error("Facebook SDK not loaded yet.");
    }
  };

  return { loginWithFacebook };
};
